import React, { useState, useEffect, useRef } from "react";
import { FaTimes } from "react-icons/fa";
const Autocomplete = ({
  data,
  idField,
  valueField,
  onQueryChange,
  onSelect,
  placeholder,
  setAutoComLoader,
  isAutoComLoader,
  selectedItem,
  width,
  height,
  extraClass,
  onClear,
}) => {
  const [query, setQuery] = useState("");
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const autocompleteRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        autocompleteRef.current &&
        !autocompleteRef.current.contains(event.target)
      ) {
        setIsDropdownVisible(false);
        setAutoComLoader(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [setAutoComLoader]);

  useEffect(() => {
    if (selectedItem === null || selectedItem === "") {
      setQuery("");
    } else if (selectedItem) {
      setQuery(selectedItem[valueField] || "");
    }
  }, [selectedItem, valueField]);

  const handleChange = (event) => {
    const newQuery = event.target.value;
    setQuery(newQuery);
    onQueryChange(newQuery);
    setIsDropdownVisible(true);
    if (newQuery === "") {
      setAutoComLoader(false);
    }
  };

  const handleSelect = (item) => {
    setQuery(item[valueField]);
    onSelect(item);
    setIsDropdownVisible(false);
  };

  return (
    <div className="relative" ref={autocompleteRef}>
      <div
        className={`flex items-center border rounded-sm overflow-hidden ${
          width ?? ""
        } ${height ?? ""} ${extraClass ?? ""} `}
      >
        <input
          type="text"
          value={query}
          onChange={handleChange}
          placeholder={placeholder || `Type to search...`}
          className="flex-1 p-2 border-none outline-none"
        />
        {isAutoComLoader && (
          <div className="flex items-center p-2">
            <img src="/img/loading.gif" className="w-7" alt="" />
          </div>
        )}
        {selectedItem?.backlink_id && onClear && (
          <button
            className="absolute inset-y-0 right-0 px-3 py-0 bg-gray-100 mt-1 rounded-r dark:border-white/20"
            onClick={onClear}
          >
            <FaTimes className="h-5 w-5 text-black" />
          </button>
        )}
      </div>
      {isDropdownVisible && data?.length > 0 && (
        <ul className="absolute z-50 mt-2 w-full bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-auto">
          {data.map((item) => (
            <li
              key={item[idField]}
              onClick={() => handleSelect(item)}
              className="p-2 hover:bg-gray-200 cursor-pointer border-b border-gray-200 "
            >
              {item[valueField]}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Autocomplete;
